module.exports = __webpack_public_path__ + "static/extra_4_mobile-33e29d35560e07cbc483a525417f1df5.jpg";